import React from 'react'; 
import './Home.css';   
import Card from '../Card/Card'; 
import hero from '../../assets/hero.png'; 
import { cardData } from '../Card/CardData';  

function Home() {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <img src={hero} alt="Hero" className="hero-image" />
        <div className="hero-overlay">
          <div className="welcome-text">
            <p>Welcome to Fix and Flip!</p>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div className="cards-container">
        {cardData && cardData.length > 0 ? (
          cardData.map(card => (
            <Card
              key={card.id}
              image={card.image}
              title={card.title}
              text={card.text}
              reverse={card.reverse}
            />
          ))
        ) : (
          <p>No cards available</p>
        )}
      </div>
    </div>
  );
}

export default Home;